<template>
  <div>
    <div class="container" flex>
      <div class="image">
        <img
          src="../../../../../../src/assets/img/mypage/exclamation_mark_ic.svg"
          alt=""
          class="exclamation-mark"
        />
      </div>
      <div class="text">{{ topcontent }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    topcontent: String,
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding: 8px 12px;
  border-radius: 4px;
  border: solid 1px #dcdfe3;
  background-color: #fff;
  .image {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .text {
    padding-left: 24px;
  }
  .sub-color {
    color: #00b473;
  }
}
</style>
